import { useAuth } from "@/context/AuthContext";
import SubscriptionPlans from "@/components/SubscriptionPlans";
import { Leaf, SignOut } from "@phosphor-icons/react";

export default function SubscriptionGate() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-[#F8F9FA] p-4 sm:p-8" data-testid="subscription-gate">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-md bg-[#2E2E2E] flex items-center justify-center">
              <Leaf size={22} weight="fill" className="text-[#3BB54A]" />
            </div>
            <span className="font-display font-black text-xl text-[#2E2E2E]">MowGuru</span>
          </div>
          <button onClick={logout} data-testid="gate-logout"
            className="h-10 px-4 rounded-full border border-border text-muted-foreground font-semibold flex items-center gap-2 hover:bg-white transition-colors">
            <SignOut size={18} /> Log out
          </button>
        </div>
        <div className="text-center mb-8">
          <h1 className="font-display font-black text-3xl sm:text-4xl text-[#2E2E2E]">Your free trial has ended</h1>
          <p className="text-muted-foreground mt-2">
            Hi {user?.name?.split(" ")[0] || "there"} — choose a plan to keep managing your lawn-care business.
          </p>
        </div>
        <SubscriptionPlans />
      </div>
    </div>
  );
}
